import { TrackingMiddleware } from '../types';

const eventDebugger: TrackingMiddleware = () => async event => {
  console.info(
    JSON.stringify({
      message: 'Would have tracked event',
      eventName: event.name,
      _data: event.data,
      _context: event.context,
    })
  );
  event.apply({
    __debugMode: true,
  });
};

export default eventDebugger;
